export default __webpack_public_path__ + "static/media/bell.00722cf4.png";